import {charcoal} from '../../sass/v2/_exports.sass';

export const CalendarIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33333 14.6667H12V17.3333H9.33333V14.6667ZM9.33333 20H12V22.6667H9.33333V20ZM14.6667 14.6667H17.3333V17.3333H14.6667V14.6667ZM14.6667 20H17.3333V22.6667H14.6667V20ZM20 14.6667H22.6667V17.3333H20V14.6667ZM20 20H22.6667V22.6667H20V20Z"
        fill={color}
      />
      <path
        d="M6.66667 29.3333H25.3333C26.804 29.3333 28 28.1373 28 26.6667V7.99999C28 6.52932 26.804 5.33332 25.3333 5.33332H22.6667V2.66666H20V5.33332H12V2.66666H9.33333V5.33332H6.66667C5.196 5.33332 4 6.52932 4 7.99999V26.6667C4 28.1373 5.196 29.3333 6.66667 29.3333ZM25.3333 10.6667L25.3347 26.6667H6.66667V10.6667H25.3333Z"
        fill={color}
      />
    </svg>
  );
};
